import React, { useCallback, useState } from 'react';
import { Outlet } from 'react-router-dom';
import { ArrowRightOnRectangleIcon } from '@heroicons/react/24/outline';
import AccountNav from './AccountNav';

const AccountPage = () => {
  const [loggingOut, setLoggingOut] = useState(false);

  const handleLogout = useCallback(async () => {
    setLoggingOut(true);
    try {
      const res = await fetch('/api/auth/logout', {
        method: 'POST',
        credentials: 'include',
      });
      if (!res.ok) {
        throw new Error(`Logout failed (${res.status})`);
      }
      window.location.assign('/');
    } catch (e) {
      setLoggingOut(false);
      console.error(e);
    }
  }, []);

  return (
    <main className="relative z-0 mx-auto max-w-6xl px-4 py-10 sm:px-6">
      <div className="flex flex-col gap-6 lg:flex-row lg:gap-8">
        <aside className="w-full shrink-0 lg:w-52">
          <div className="rounded-2xl border-[3px] border-ink/15 bg-white/90 p-3 shadow-[4px_6px_0_rgba(44,44,44,0.08)]">
            <AccountNav />
            <div className="mt-3 border-t border-ink/10 pt-3">
              <button
                type="button"
                disabled={loggingOut}
                onClick={() => void handleLogout()}
                className="flex w-full items-center gap-2 rounded-xl px-3 py-2 text-left font-sans text-sm font-semibold text-ink/75 transition hover:bg-ink/5 hover:text-ink focus-visible:outline-none focus-visible:ring-2 focus-visible:ring-ink/30 disabled:cursor-not-allowed disabled:opacity-50"
              >
                <ArrowRightOnRectangleIcon className="h-4 w-4 shrink-0 text-ink/50" aria-hidden />
                {loggingOut ? 'Signing out…' : 'Log out'}
              </button>
            </div>
          </div>
        </aside>

        <div className="min-w-0 flex-1">
          <Outlet />
        </div>
      </div>
    </main>
  );
};

export default AccountPage;
